// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_availability_order = /** @type {(inputs: {}) => string} */ () => {
	return `Available in 2-3 weeks`
};

const el_availability_order = /** @type {(inputs: {}) => string} */ () => {
	return `Διαθέσιμο σε 2-3 εβδομάδες`
};

const ru_availability_order = /** @type {(inputs: {}) => string} */ () => {
	return `Доступно через 2-3 недели`
};

const he_availability_order = /** @type {(inputs: {}) => string} */ () => {
	return `זמין תוך 2-3 שבועות`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const availability_order = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.availability_order(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("availability_order", locale)
	if (locale === "en") return en_availability_order(inputs)
	if (locale === "el") return el_availability_order(inputs)
	if (locale === "ru") return ru_availability_order(inputs)
	if (locale === "he") return he_availability_order(inputs)
	return "availability_order"
};